var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.linkClass},[_c('a',{attrs:{"href":_vm.mNbr},on:{"click":function($event){$event.preventDefault();return _vm.aClick($event)}}},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }